const showDebuggerMessages =
  import.meta.env.VITE_SHOW_CONSOLE_DEBUGGER === 'true'

export const useDebugger = () => {
  const $debug = (message) => {
    if (!showDebuggerMessages) return
    console.log(`%c [Debug] ${message} `, 'background: #0000cc; color: #ffffff')
  }

  return {
    $debug,
  }
}
